class FormDataRecord {
    public name?: string;
    public value?: string;
}

export default FormDataRecord;